<template>
  <base-form
    v-model="data"
    :options="options"
    labelWidth="100px"
    :maxLabelLength="7"
    ref="form"
  ></base-form>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  import { dateFormat } from '@/filters/index';
  import { mapEnumList } from '@/common/js/enums';
  import { businessReceiptStatus } from '../data';
  // import BASEAPI from '@/api/dataBase.js';

  export default {
    props: {
      defaultData: {
        type: Object,
        default: () => {},
      },
      userInfo: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      baseForm,
    },
    data() {
      return {
        data: {
          inboundNo: null,
          inboundCreatePersonName: null,
          inboundCreatePersonNo: null,
          inboundCreateDate: null,
          inboundCompanyName: null,
          inboundCompanyNo: null,
          inboundStatus: null,
          accountingStatus: null,
        },
      };
    },
    computed: {
      options() {
        return [
          {
            type: 'input',
            label: this.$t('businessReceiptList.search.businessEntryNumber'),
            prop: 'inboundNo',
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('businessReceiptList.search.makingPeople'),
            prop: 'inboundCreatePersonName',
            disabled: true,
            required: true,
          },
          {
            type: 'date',
            label: this.$t('businessReceiptList.create.makeTime'),
            prop: 'inboundCreateDate',
            disabled: true,
            required: true,
          },
          {
            type: 'input',
            label: this.$t('businessReceiptList.search.company'),
            prop: 'inboundCompanyName',
            disabled: true,
            required: true,
          },
          {
            type: 'enumSelect',
            label: this.$t('businessReceiptList.create.status'),
            prop: 'inboundStatus',
            options: mapEnumList(businessReceiptStatus),
            disabled: true,
          },
          {
            type: 'dict',
            label: this.$t('businessReceiptList.create.accountingSatus'),
            prop: 'accountingStatus',
            // dictType: "accounting_status",
            // apiData: { dictType: "post_status" },
            // apiUrl: BASEAPI.DIC_CREDIT_API,
            dictType: 'post_status',
            disabled: true,
          },
          // {
          //   type: 'input',
          //   label: this.$t('businessReceiptList.create.reversed'),
          //   prop: 'reversed',
          //   disabled: true,
          // },
        ];
      },
    },
    mounted() {},
    methods: {
      setData(info) {
        const userInfo = this.userInfo;
        Object.keys(this.data).map((key) => {
          return (this.data[key] = info[key]);
        });
        if (!this.data.inboundCreatePersonNo) this.data.inboundCreatePersonNo = userInfo.userCode;
        if (!this.data.inboundCreatePersonName)
          this.data.inboundCreatePersonName = userInfo.userName;
        if (!this.data.inboundCreateDate) this.data.inboundCreateDate = dateFormat(new Date());
      },
      // 获取数据
      getValues() {
        const data = this.data;
        const result = Object.assign({}, data, {});
        return result;
      },
      handleSubmit() {
        return this.$refs['form'].handleSubmit();
      },
    },
  };
</script>
